import clsx from 'clsx'
import { Text } from 'ui/src/components/Text/Text'
import { xStack } from 'ui/src/patterns/stack'
import { tokens } from 'ui/src/theme/tokens.css'
import { cartCount, cartIcon } from './ShoppingCartMenuItem.css'

export type ShoppingBagIconProps = {
  count: number
}

export function ShoppingBagIcon({ count }: ShoppingBagIconProps) {
  const hasItemsInCart = count > 0
  return (
    <div
      className={xStack({
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      })}
    >
      <svg className={clsx(cartIcon)} viewBox="0 0 24 24" fill="none">
        <path d="M15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6" strokeWidth="1.5" strokeLinecap="round" />
        <path
          d="M7 20H17C18.1046 20 19 19.1046 19 18V13V9.5V8C19 6.89543 18.1046 6 17 6H14.5H12H7C5.89543 6 5 6.89543 5 8V18C5 19.1046 5.89543 20 7 20Z"
          strokeWidth="1.5"
          fill={hasItemsInCart ? tokens.colors.fills.opaque.primary : 'none'}
        />
      </svg>

      {hasItemsInCart && (
        <Text className={cartCount} as="span" size="xxs">
          {count}
        </Text>
      )}
    </div>
  )
}
